import Div from "@jumbo/shared/Div/Div";
import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import {
  Autocomplete,
  Box,
  Button,
  InputAdornment,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  Typography,
} from "@mui/material";

import InfoIcon from "@mui/icons-material/Info";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { getAllShopOrdersSales } from "app/redux/actions/salesAction";
import { CuttingListInfoModal } from "app/pages/Order/Cutter/List/cuttingListInfoModal";
import { displayDateFun } from "app/utils/constants/functions";
import FullScreenLoader from "app/components/ListingPageLoader";

export default function ShopOrderSalesTable({ searchTerm, page, setPage, inputs }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("id");
  const [isItemOpen, setIsItemOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);

  const handleSort = (property) => {
    const isAscending = orderBy === property && order === "asc";
    setOrder(isAscending ? "desc" : "asc");
    setOrderBy(property);
  };
  const { allShopOrderSales, TotalPage, loading } = useSelector((state) => state.shopOrderSalesReducer);
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));

  const sortedData = allShopOrderSales?.sort((a, b) => {
    let aValue;
    let bValue;
    if (orderBy == "shop_order_item_name") {
      aValue = a.order_item_name.toLowerCase();
      bValue = b.order_item_name.toLowerCase();
    } else {
      aValue = a[orderBy];
      bValue = b[orderBy];
    }
    if (order === "desc") {
      return aValue < bValue ? -1 : 1;
    } else {
      return bValue < aValue ? -1 : 1;
    }
  });

  const handleChangePage = (event, page) => {
    setPage(page);
    dispatch(getAllShopOrdersSales(searchTerm, inputs, page));
  };

  useEffect(() => {
    (async () => {
      dispatch(getAllShopOrdersSales("", "", 1));
    })();
  }, []);

  return (
    <>
      {loading && <FullScreenLoader />}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: "#202020", color: "white" }}>
              <TableCell
                sx={{
                  px: 1,
                  textAlign: "left",
                  minWidth: "140px",
                  verticalAlign: "middle",
                  color: "white",
                }}
              >
                Port No & Name
              </TableCell>
              <TableCell
                sx={{
                  px: 1,
                  textAlign: "left",
                  width: "110px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "shop_order_no"}
                  direction={order}
                  onClick={() => handleSort("shop_order_no")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Order No.
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  px: 1,
                  textAlign: "left",
                  width: "110px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "order_item_no"}
                  direction={order}
                  onClick={() => handleSort("order_item_no")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Item No.
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  px: 1,
                  textAlign: "left",
                  width: "120px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "shop_order_item_name"}
                  direction={order}
                  onClick={() => handleSort("shop_order_item_name")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Item Name
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  px: 1,
                  textAlign: "left",
                  minWidth: "120px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "shop_order_item_size"}
                  direction={order}
                  onClick={() => handleSort("shop_order_item_size")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Item Size
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  px: 1,
                  textAlign: "left",
                  minWidth: "150px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "shop_order_client_name"}
                  direction={order}
                  onClick={() => handleSort("shop_order_client_name")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Supplier Name
                </TableSortLabel>
              </TableCell>
              {/* <TableCell
                sx={{
                  px: 1,
                  textAlign: "left",
                  minWidth: "150px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "productions_invoice_no"}
                  direction={order}
                  onClick={() => handleSort("productions_invoice_no")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Factory Bill No.
                </TableSortLabel>
              </TableCell> */}
              <TableCell
                sx={{
                  px: 1,
                  textAlign: "left",
                  minWidth: "120px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "finished_invoice_date"}
                  direction={order}
                  onClick={() => handleSort("finished_invoice_date")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Invoice Date
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "150px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "cost_price_quantity"}
                  direction={order}
                  onClick={() => handleSort("cost_price_quantity")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  QTY
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "150px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "selling_price_item_price"}
                  direction={order}
                  onClick={() => handleSort("selling_price_item_price")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Rate
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "100px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "selling_price_item_price"}
                  direction={order}
                  onClick={() => handleSort("selling_price_item_price")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Item Price (USD)
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "100px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "selling_price_item_price_in_INR"}
                  direction={order}
                  onClick={() => handleSort("selling_price_item_price_in_INR")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Item Price (INR)
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "100px",
                  verticalAlign: "middle",
                  color: "white",
                }}
              >
                <TableSortLabel
                  active={orderBy === "selling_price_addOns_price"}
                  direction={order}
                  onClick={() => handleSort("selling_price_addOns_price")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Add Ons Price
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "100px",
                  verticalAlign: "middle",
                  color: "white",
                }}
              >
                <TableSortLabel
                  active={orderBy === "cost_price_suit_cover_cost"}
                  direction={order}
                  onClick={() => handleSort("cost_price_suit_cover_cost")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Suit Cover Price
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "100px",
                  verticalAlign: "middle",
                  color: "white",
                }}
              >
                <TableSortLabel
                  active={orderBy === "selling_price_freight"}
                  direction={order}
                  onClick={() => handleSort("selling_price_freight")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Freight
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "100px",
                  verticalAlign: "middle",
                  color: "white",
                }}
              >
                <TableSortLabel
                  active={orderBy === "selling_price_other_charges"}
                  direction={order}
                  onClick={() => handleSort("selling_price_other_charges")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Other Charges
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "100px",
                  verticalAlign: "middle",
                  color: "white",
                }}
              >
                <TableSortLabel
                  active={orderBy === "total_selling_price"}
                  direction={order}
                  onClick={() => handleSort("total_selling_price")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Total (SP)
                </TableSortLabel>
              </TableCell>
              {permissions?.sales_edit == true && (
                <TableCell
                  sx={{
                    textAlign: "left",
                    minWidth: "95px",
                    verticalAlign: "middle",
                    color: "white",
                    px: 1,
                    position: "sticky",
                    right: 0,
                    height: "58px",
                    zIndex: 1,
                    bgcolor: "#202020",
                  }}
                >
                  Action
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData?.map((row, i) => (
              <TableRow key={i}>
                <TableCell sx={{ textAlign: "left", px: 1 }}>{row?.shop_order_port_no_and_name}</TableCell>
                <TableCell sx={{ textAlign: "left", px: 1 }}>{row?.shop_order_no}</TableCell>
                <TableCell sx={{ textAlign: "left", px: 1 }}>{row?.shop_order_item_no}</TableCell>
                <TableCell sx={{ textAlign: "left", px: 1 }}>{row?.shop_order_item_name}</TableCell>
                <TableCell sx={{ textAlign: "left", px: 1 }}>{row?.shop_order_item_size}</TableCell>
                <TableCell sx={{ textAlign: "left", px: 1 }}>{row?.shop_order_client_name}</TableCell>
                {/* <TableCell sx={{ textAlign: "left", px: 1 }}>{row?.finished_invoice_no}sd</TableCell> */}
                <TableCell sx={{ textAlign: "left", px: 1 }}>{displayDateFun(row?.finished_invoice_date)}</TableCell>
                <TableCell sx={{ textAlign: "left", px: 1 }}>
                  {row?.cost_price_quantity ? row?.cost_price_quantity : "-"}
                </TableCell>
                <TableCell sx={{ textAlign: "left", px: 1 }}>
                  {row?.cost_price_rate ? row?.cost_price_rate : "-"}
                </TableCell>
                <TableCell sx={{ textAlign: "left" }}>
                  {row?.selling_price_item_price ? Math.round(row?.selling_price_item_price) : "-"}
                </TableCell>
                <TableCell sx={{ textAlign: "left" }}>
                  {row?.selling_price_item_price_in_INR ? Math.round(row?.selling_price_item_price_in_INR) : "-"}
                </TableCell>
                <TableCell sx={{ textAlign: "left" }}>{row?.selling_price_addOns_price ? row?.selling_price_addOns_price : "-"}</TableCell>
                <TableCell sx={{ textAlign: "left" }}>{row?.cost_price_suit_cover_cost ? row?.cost_price_suit_cover_cost : "-"}</TableCell>
                <TableCell sx={{ textAlign: "left" }}>{row?.selling_price_freight ? row?.selling_price_freight : "-"}</TableCell>
                <TableCell sx={{ textAlign: "left" }}>
                  {row?.selling_price_other_charges ? row?.selling_price_other_charges : "-"}
                </TableCell>
                <TableCell sx={{ textAlign: "left" }}>{row?.total_selling_price ? Math.round(row?.total_selling_price) : "-"}</TableCell>
                {permissions?.sales_edit == true && (
                  <TableCell
                    sx={{
                      textAlign: "left",
                      px: 1,
                      position: "sticky",
                      right: 0,
                      zIndex: 1,
                      bgcolor: "white",
                    }}
                  >
                    <Typography
                      size="small"
                      fontWeight={600}
                      sx={{
                        cursor: "pointer",
                        ":hover": { color: "purple" },
                      }}
                      onClick={() => {
                        navigate("/dashboard/sales/edit-shop-order", { state: row });
                      }}
                    >
                      Edit
                    </Typography>
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
          <CuttingListInfoModal
            type="normalOrder"
            open={isItemOpen}
            onClose={() => {
              setIsItemOpen(false);
            }}
            rowData={selectedRowData}
          />
        </Table>
        <Pagination
          count={TotalPage || 1} // Replace with the actual total number of pages
          page={page}
          onChange={handleChangePage}
          sx={{
            position: "sticky",
            bottom: 0,
            left: 0,
            backgroundColor: "white",
            borderTop: "1px solid #ddd",
            p: 2,
          }}
        />
      </TableContainer>
    </>
  );
}
